import type { Route } from './types';

const getRoute = (
  originId?: Route['originId'],
  originName?: Route['originName'],
  destinationId?: Route['destinationId'],
  destinationName?: Route['destinationName'],
  destinationCityName?: Route['destinationCityName'],
  destinationEntityId?: Route['destinationEntityId'],
  originEntityId?: Route['originEntityId'],
): Route => ({
  originId: originId ?? '',
  originName: originName ?? '',
  destinationId: destinationId ?? '',
  destinationName: destinationName ?? '',
  destinationCityName: destinationCityName ?? '',
  destinationEntityId: destinationEntityId ?? '',
  originEntityId: originEntityId ?? '',
});

export default getRoute;
